import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '@common/components/icon';
import { useChatStore } from '@modules/chat/store/chatStore';

const NoConversationSelected = () => {
  const { t } = useTranslation();

  const { isSearchFocused } = useChatStore();

  const title = isSearchFocused ?
    t('chat:no_conversation_selected_title_search') :
    t('chat:no_conversation_selected_title');

  const description = isSearchFocused ?
    t('chat:no_conversation_selected_description_search') :
    t('chat:no_conversation_selected_description');

  return (
    <div className="tw-flex tw-items-center tw-justify-center tw-h-full tw-w-full">
      <div className="tw-bg-white tw-rounded-lg tw-shadow tw-max-w-lg">
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-6 tw-text-center">
          <div className="tw-mb-6 tw-text-neutral-400">
            <Icon type="chat__filled" className="tw-w-16 tw-h-16" />
          </div>
          <h2 className="tw-text-2xl tw-font-medium tw-mb-2 tw-text-neutral-900">
            {title}
          </h2>
          <p className="tw-text-neutral-600 tw-max-w-md">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoConversationSelected;
